(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name tracking.filter:trackingFlight
     *
     * @description
     *
     * @param {Array} input The array to filter
     * @returns {Array} The filtered array
     *
     */
    angular
        .module('tracking')
        .filter('trackingFlight', trackingFlight);

    function trackingFlight() {

        var lastFilter = null;

        var getPairs = function (pairsCol, filter) {
            var filtered = [];
            var isFilterEnable = false;
            angular.forEach(Object.keys(filter.flags), function (key) {
                isFilterEnable = isFilterEnable || filter.flags[key];
            })


            if (isFilterEnable) {
                angular.forEach(pairsCol, function (pair) {
                    if (
                        (filter.flags.isCrewCompositionFilterOn && pair.flags.crewComposition) ||
                        (filter.flags.isIllagalNextFilterOn && pair.flags.illagalNextWarning) ||
                        (filter.flags.isExpiriesFilterOn && pair.flags.crewExpiryWarnings) ||
                        (filter.flags.isGenderFilerOn && pair.flags.genderWarnings) ||
                        (filter.flags.isIllegalCurrentFilterOn && pair.flags.illagalCurrentWarning) ||
                        (filter.flags.isLabguageFilterOn && pair.flags.languageWarnings)
                    ) {
                        filtered.push(pair);
                    }
                });
            } else {
                filtered = pairsCol;
            }
            return filtered;
        }

        return function (input, filter) {
            if (input.length > 0) {
                if (!!filter && !angular.equals(lastFilter, filter)) {
                    lastFilter = angular.copy(filter);
                    var filteredCol = _.map(input, function (flight) {
                        flight.pairs = getPairs(flight.pairsUntouch, filter);
                        if (flight.pairs.length > 0) {
                            flight.orderKey = 1;
                        } else {
                            flight.orderKey = 0;
                        }
                        return flight;
                    });
                    return filteredCol;
                } else {
                    return input;
                }
            }
        };
    }
}());
